module.exports = __webpack_public_path__ + "img/Zaun.b3de41c1.jpg";